import { ImageSourceSetData } from "./ImageSourceSet";

export interface SonicRelatedFacilityData {
  id: string;
  name: string;
  imgs?: ImageSourceSetData[];
  prefecture: string;
  traits: Array<string>;
  price_status: string;
  seating_capacity_max?: number;
  seating_capacity_text?: string;
  select_review: string;
}

export class SonicRelatedFacility implements SonicRelatedFacilityData {
  id: string;
  name: string;
  imgs?: ImageSourceSetData[];
  prefecture: string;
  traits: Array<string>;
  price_status: string;
  seating_capacity_max?: number;
  seating_capacity_text?: string;
  select_review: string;

  constructor(
    id: string,
    name: string,
    prefecture: string,
    traits: Array<string>,
    price_status: string,
    select_review: string,
    imgs?: ImageSourceSetData[],
    seating_capacity_max?: number,
    seating_capacity_text?: string
  ) {
    this.id = id;
    this.name = name;
    this.imgs = imgs;
    this.prefecture = prefecture;
    this.traits = traits;
    this.price_status = price_status;
    this.select_review = select_review;
    this.seating_capacity_max = seating_capacity_max;
    this.seating_capacity_text = seating_capacity_text;
  }

  static parseFromAPIResponse(item: any) {
    return new SonicRelatedFacility(
      item.id,
      item.name,
      item.prefecture,
      item.traits,
      item.price_status,
      item.select_review,
      item.imgs,
      item.seating_capacity_max,
      item.seating_capacity_text
    );
  }
}
